<template>
  <div class="user-bar">
    <component :is="headingTag" class="page-title">{{ pageTitle }}</component>

    <div class="user-dropdown" ref="dropdown">
      <button class="user-button" @click.stop="toggleDropdown">
        <i class="bi bi-person-circle"></i>
        <span>{{ username }}</span>
        <i class="bi bi-chevron-down"></i>
      </button>

      <div v-if="dropdownVisible" class="dropdown-menu show">
        <router-link
          :to="{ name: 'Profile', params: { id: userid } }"
          class="dropdown-item"
          @click="closeDropdown"
        >
          {{ $t("sidebar.profile") }}
        </router-link>
        <button @click="logout" class="dropdown-item">
          {{ $t("sidebar.logout") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    userData: Object,
    pageTitle: String,
  },
  data() {
    return {
      dropdownVisible: false,
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    username() {
      return this.user?.username || "Guest";
    },
    userid() {
      return this.user?.userid || "Guest";
    },
    headingTag() {
      return this.isMobile ? "h6" : "h1";
    },
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation();
      this.dropdownVisible = !this.dropdownVisible;
    },
    closeDropdown() {
      this.dropdownVisible = false;
    },
    logout() {
      this.$emit("logout");
      this.closeDropdown();
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
